// extracted by mini-css-extract-plugin
export default {"redTextWrapper":"consolidationInfo_redTextWrapper__QPvBf"};